import React from "react";
import Loader from "react-loader-spinner";

// @todo: vk - replace instances of Loader with ThemeLoader
// set default props to use theme variables
const defaultParams = {
	type: "ThreeDots",
	color: "#2BAD60",
	height: 100,
	width: 100,
	customClass: "default-loader",
};

export const InputLoader = (props) => (
	<div className="p-1 bg-faded text-muted text-center">
		<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
		<span className="sr-only">Loading...</span>
	</div>
);

const ThemeLoader = (props) => (
	<div className={`container-fluid theme-loader ${props.customClass || defaultParams.customClass}`}>
		<Loader type={props.type || defaultParams.type} color={props.color || defaultParams.color} height={props.height || defaultParams.height} width={props.width || defaultParams.width} />
	</div>
);

export default ThemeLoader;
